import { useNavigate } from 'react-router';

// material-ui
import Badge from '@mui/material/Badge';
import Box from '@mui/material/Box';

// project-imports
import IconButton from 'components/@extended/IconButton';
import { useUnreadNotificationCount } from 'api/vektra/hooks';

// assets
import { Notification } from 'iconsax-reactjs';

// ==============================|| HEADER CONTENT - NOTIFICATION ||============================== //

export default function NotificationPage() {
  const navigate = useNavigate();
  const { data: unreadCount } = useUnreadNotificationCount();

  return (
    <Box sx={{ flexShrink: 0, ml: 0.5 }}>
      <IconButton
        color="secondary"
        variant="light"
        aria-label="open notifications"
        onClick={() => navigate('/notifications')}
        size="large"
        sx={(theme) => ({
          p: 1,
          color: 'secondary.main',
          bgcolor: 'secondary.100',
          ...theme.applyStyles('dark', { bgcolor: 'background.default' })
        })}
      >
        <Badge badgeContent={unreadCount ?? 0} color="success" slotProps={{ badge: { sx: { top: 2, right: 4 } } }}>
          <Notification variant="Bold" />
        </Badge>
      </IconButton>
    </Box>
  );
}
